export const COLLECTIONS = {
  item: 'item',
  account: 'account',
  item_category: 'item_category',
  item_main_categories: 'item_main_categories',
  item_modifier_group: 'item_modifier_group',
  location: 'location',
  order: 'order',
  promotion: 'promotion',
  reward: 'reward',
  totals: 'totals',
  balance: 'registered_balance',
  transaction: 'transaction',
  reports_OT_w: 'weekly_reports',
  reports_OT_m: 'monthly_reports',
  reports_IT_w: 'item_stats_w',
  reports_IT_m: 'item_stats_m',
  reports_IT_daily: 'item_stats_daily',
  day_wise_order_reports: 'day_wise_order_summary',
  order_app_versions: 'order_app_versions',
  square_ord_reports: 'square_daywise_reports',
  activity_logs: 'activity_logs',
  builds: 'builds',
  sync_accounts: 'sync_accounts',
  coupons: 'coupons',
  coupons_stats: 'coupons_stats',
  vouchers: 'vouchers',
  vouchers_stats: 'vouchers_stats',
  configs: 'configs',
  giftCards: 'giftCards',
  notes: 'notes',
  stats: 'statistics',
  matto_events: 'matto_events',
  matto_events_stats: 'matto_events_stats',
  notifications: 'notifications',
  devices_user: 'devices_user',
  item_stock_history: 'item_stock_history',
  item_stock_monthly_report: 'item_stock_monthly_report',
  web_notification_tokens: 'web_notification_tokens',
  modifier_reports: 'modifier_reports',
  transaction_reports: 'day_wise_transaction_reports',
  ledger: 'ledger', // collectionGroup
  cat_subcat_mod_reports: 'cat_subcat_mod_reports',
  sent_gift_cards: 'sent_gift_cards',
  referral_code: 'referral_code',
  taylor_in_miami_user: 'taylor_in_miami_user',
  balance_transfers: 'balance_transfers',
};

export const ACCESS_LEVELS = {
  VIEW: 'view',
  EDIT: 'edit',
} as const;

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  MANAGER: 'manager',
  INSIGHTS: 'insights',
} as const;

export const NEXT_GEN_ROLES = {
  SUPER_ADMIN: 'super_admin', // can do anything (and manage users)
  APP_ADMIN: 'app_admin', // can interact with the app administartion product
  STORE_MANAGER: 'store_manager', // can manage stores and has access to store app only
  INSIGHT_MANAGER: 'insight_manager', // can view insights and reports
};

export const DAY_CODES = {
  SUNDAY: 'd00',
  MONDAY: 'd01',
  TUESDAY: 'd02',
  WEDNESDAY: 'd03',
  THURSDAY: 'd04',
  FRIDAY: 'd05',
  SATURDAY: 'd06',
};

export const STORE_LOCATION_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  HIDDEN: 'HIDDEN',
} as const;

export const SYNC_ACCOUNT_STATUSES = {
  NEW: 'new',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
} as const;

export const ORDER_STATUSES = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  INCOMPLETE: 'INCOMPLETE',
  NEW: 'NEW',
} as const;

export const NOTIFICATION_TYPES = {
  PRODUCT: 'product',
  EVENT: 'event',
  COUPON: 'coupon',
  LOCATION: 'location',
  REWARD: 'reward',
  TAYLORINMIAMIPROMO: 'taylorInMiamiPromo',
  OTHER: 'other',
} as const;

export const NOTIFICATION_STATUSES = {
  PENDING: 'pending',
  DONE: 'done',
} as const;

export const NOTIFICATION_SCHEDULE_TYPES = {
  NOW: 'now',
  SCHEDULED: 'scheduled',
  PERIODIC: 'periodic',
} as const;

export const NOTIFICATION_RECIPIENTS = {
  ALL: 'all',
  SIGNED_IN: 'signedIn',
  TAYLOR_IN_MIAMI_USERS: 'taylorInMiamiUsers',
} as const;

export const PLATFORM_PRODUCTS = {
  APP_ADMINISTRATION: 'appAdministration',
  INSIGHTS: 'insights',
  ACCOUNTING: 'accounting',
  INVENTORY: 'inventory',
};

export const PAYMENT_TYPES = {
  TRANSACTION_REFUND: 'TRANSACTION REFUND',
  BALANCE_INCREMENT: 'BALANCE INCREMENT',
  BALANCE_DECREMENT: 'BALANCE DECREMENT',
  AUTO_REFILL: 'AUTO REFILL',
  GIFT_CARD_LOAD: 'GIFT CARD LOAD',
  DIGITAL_GIFT_CARD_CREATE: 'DIGITAL GIFT CARD CREATE',
  SENT_DIGITAL_GIFT_CARD: 'SENT DIGITAL GIFT CARD',
};

export const PAYMENT_METHODS = {
  ADMIN_PANEL: 'ADMIN PANEL',
  SQUARE_CARD: 'SQUARE CARD',
  PAYPAL: 'PAYPAL',
  APPLE_PAY: 'APPLE PAY',
  GOOGLE_PAY: 'GOOGLE PAY',
};
